import { FC } from "react";

import { IconType } from "@types";

import { Icon } from "components/atoms/Icon/Icon";

import { StructuredText } from "components/sections/RichtextSection/StructuredText";
import { ChecklistItemRecord } from "@graphql/types/graphql";
import s from "./ChecklistItem.module.scss";

interface Props {
  data: ChecklistItemRecord;
}

export const ChecklistItem: FC<Props> = ({ data: { title, text } }) => (
  <div className={s.ChecklistItem}>
    <span className={s.Icon}>
      <Icon name={IconType.Check} size="xl" color="blue" />
    </span>
    <div className={s.Title}>{title}</div>
    <div className="prose">
      <StructuredText structuredText={text as any} />
    </div>
  </div>
);
